import styled from "@emotion/styled";
import Button from "@/components/atoms/Button";
import breakpoint from "@/utils/breakpoint";

const FormButton = styled(Button)`
  width: 342px;
  height: 60px;
  background: #dd690a;
  box-shadow: 0px 5px 0px #c25c09;
  border-radius: 4px;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  line-height: 35px;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  align-items: flex-start;
  padding: 0 0 0 15px;

  ${breakpoint.lessThan("sm")`
    width: 100%;
    height: 50px;
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    line-height: 26px;
  `}

  &:disabled {
    background: #c25c08;
    box-shadow: 0px 5px 0px #c25c09;
    opacity: 0.7;
  }
`;

export default FormButton;
